import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { Signature } from '../../../types/user';
import environmentConfigs from '../../../config/environment-configs';
import { concatenateStringList } from '../../../util/formatItens';

import { Link } from '../../../components/Link/styles';
import { Actions, Categories } from '../../../types/gtm';
import { ItemSignature, TitleProduct } from '../styles';
import Icon from '../../../components/Section/Icon';
import svg from '../../../static/img/icon-open-menu.svg';

export const ItemWebSignature = ({
  signatures,
  globoId,
}: {
  signatures: Signature[];
  globoId: string;
}) => {
  const [cookies] = useCookies();
  const [namesSignatures, setNamesSignatures] = useState<string[]>([]);

  useEffect(() => {
    if (signatures && signatures.length > 0) {
      const names = signatures.map(s => s.name);
      setNamesSignatures(names);
    }
  }, [signatures]);

  const origemId = cookies.f_origemId || '2001';
  const redirectUrl = `${environmentConfigs.ACCOUNT_MANAGEMENT_DEFAULT_DNS_URL}/`;

  const handleRedirect = environmentConfigs.ASSIGNATURE_URL.replace(
    ':origemId',
    origemId,
  )
    .replace(':url', redirectUrl)
    .replace(':glbid', globoId);

  if (namesSignatures.length === 0) {
    return <></>;
  }

  return (
    <ItemSignature key={`signature-web-${String(namesSignatures?.length)}`}>
      <TitleProduct>{concatenateStringList(namesSignatures)}</TitleProduct>
      <p>
        Acesse o <strong>gerenciamento de assinatura</strong> para cancelar sua
        assinatura.
      </p>
      <Link
        href={handleRedirect}
        onClick={() => {
          window.dataLayer.push({
            event: 'customEventUserInteraction',
            event_category: Categories.DeleteAccount,
            event_action: Actions.ClickSubscriptionsManagement,
            bd_suser_code: globoId,
          });
        }}
      >
        Gerenciamento de assinatura
        <Icon svg={svg} alt="icon-open-menu" />
      </Link>
    </ItemSignature>
  );
};
